import loadConfigFromMeta from '@embroider/config-meta-loader'

export default loadConfigFromMeta('district-ui-client')
